import Shape from './Shape';
import Coords from '../Util/Coords';

export default class Polygon extends Shape {

    constructor(p1) {
        super();
        this.points = [p1, p1];
        this.isClosed = false;
    }

    isShape() {
        return true;
    }

    export() {
        return {
            id: this.id,
            type: 'polygon',
            layer: this.layer,
            points: this.points,
            props: this.props.export('polygon'),
        }
    }

    load (props) {
        super.load(props);
        this.isClosed = true;
    }

    updateProp(key, value) {
        if (key === 'addPoint') {
            this.points.push([...value]);
        } else if (/movePoint:(\d+)/gi.test(key)) {
            let reg = /movePoint:(\d+)/gi.exec(key);
            let index = parseInt(reg[1]) || 0;
            this.points[index] = [...value];
            if (index === 0) {
                this.points[this.points.length - 1] = [...value];
            }
        } else if (key === 'lastPoint') {
            this.points[this.points.length - 1] = [...value];
        }
    }

    checkIsClosingPath() {
        let p1 = this.points[0];
        let p2 = this.points[this.points.length - 1];

        let x = p2[0]-p1[0];
        let y = p2[1]-p1[1];
        let distance = Math.sqrt(x*x + y*y);

        if(distance < 0.1 && this.points.length > 2) {
            this.points[this.points.length - 1] = this.points[0];
            this.isClosed = true;
        }
    }

    isHover (point) {
        let x = point[0];
        let y = point[1];
        
        let inside = false;
        let j = this.points.length - 1;
        for (let i = 0; i<this.points.length; i++) {
            let xi = this.points[i][0];
            let yi = this.points[i][1];
            let xj = this.points[j][0];
            let yj = this.points[j][1];
            
            let intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) {
                inside = !inside;
            }

            j = i;
        }

        return inside ? this.id : false;
    }

    isUnderSelection(bounds) {
        return !this.points.some(p => !Coords.inRect(p, bounds));
    }

    isHoverPoint(p, props) {
        for (let i in this.points) {
            let pn = this.points[i];
            let p1 = Coords.toView(pn, props.viewCenter, props.lookingAt, props.tileSize);
            let dx = p[0] - p1[0];
            let dy = p[1] - p1[1];

            if (Math.sqrt(dx*dx + dy*dy) < 12) {
                return `movePoint:${i}`;
            }
        }

        return false;
    }

    getMoveableProps() {
        return [...this.points];
    }

    relativeMove(point, origin, initialState) {
        let dx = point[0] - origin[0];
        let dy = point[1] - origin[1];

        for (let i in initialState) {
            this.updateProp(`movePoint:${i}`, [initialState[i][0] + dx, initialState[i][1] + dy]);
        }
    }

    draw(props) {
        let first = true;
        
        if (!props.hover) {
            if (!this.isClosed) {
                this.ctx.strokeStyle = 'rgba(255,255,255,0.3)';
            } else {
                this.ctx.strokeStyle = '#1e1e1e';
            }
            this.ctx.lineWidth = 3;
        } else {
            this.ctx.strokeStyle = '#0ff';
            this.ctx.lineWidth = 6;
        }
        this.ctx.fillStyle = this.props.color;

        this.ctx.beginPath();
        for(let p of this.points) {
            let pView = Coords.toView(p, props.viewCenter, props.lookingAt, props.tileSize);
            if (first) {
                this.ctx.moveTo(pView[0], pView[1]);
                first = false;
            } else {
                this.ctx.lineTo(pView[0], pView[1]);
            }
        }
        this.ctx.closePath();
        this.ctx.stroke();
        this.ctx.fill();

        if (props.hover) {
            this.ctx.fillStyle = '#0ff';
            this.ctx.strokeStyle = '#0ff';
            this.ctx.lineWidth = 6;

            for (let i in this.points) {
                if (i === this.points.length - 1) {
                    continue;
                }
                
                let p = this.points[i];
                let pView = Coords.toView(p, props.viewCenter, props.lookingAt, props.tileSize);
                this.ctx.fillRect(pView[0]-5, pView[1]-5, 10, 10);
                this.ctx.strokeRect(pView[0]-5, pView[1]-5, 10, 10);
            }

        }
    }

}